import React from 'react';
import { Button, Text, TextContent, TextVariants } from '@patternfly/react-core';
import CheckIcon from '@patternfly/react-icons/dist/js/icons/check-icon';
import '../Feedback/Feedback.css';
import { LocaleContext } from '../context/LocaleContext';
const FeedbackSuccess = ({ onCloseModal, successTitle, successDescription }) => {
    const intl = React.useContext(LocaleContext);
    return (React.createElement("div", { className: "chr-c-feedback-success-content" },
        React.createElement(CheckIcon, { color: "var(--pf-global--success-color--100)", className: "pf-u-mx-auto" }),
        React.createElement(TextContent, null,
            React.createElement(Text, { component: TextVariants.h1 }, successTitle),
            React.createElement(Text, null, successDescription)),
        React.createElement(Button, { variant: "primary", onClick: onCloseModal }, intl.close)));
};
export default FeedbackSuccess;
